/**
 * 📦 Package Enums — القيم المسموحة في البكج
 *
 * Source of Truth: havlaa_packages_system_documentation_ar.md
 */

// ═══════════════════════════════════════════════════
// Section Mode (نوع القسم)
// ═══════════════════════════════════════════════════
export const SectionMode = {
  BOTH: 'both',     // قسمين (رجال + نساء)
  MEN: 'men',       // رجال فقط
  WOMEN: 'women',   // نساء فقط
} as const;

export type SectionModeValue = (typeof SectionMode)[keyof typeof SectionMode];

export const SectionModeLabels: Record<SectionModeValue, string> = {
  both: 'قسمين',
  men: 'رجال فقط',
  women: 'نساء فقط',
};

export const SectionModeIcons: Record<SectionModeValue, string> = {
  both: '👫',
  men: '👨',
  women: '👩',
};

// ═══════════════════════════════════════════════════
// Day Type (نوع اليوم)
// ═══════════════════════════════════════════════════
export const DayType = {
  ALL: 'all',                   // كل الأيام
  WEEKDAY: 'weekday',           // وسط الأسبوع (السبت–الأربعاء)
  WEEKEND: 'weekend',           // ويكند (الخميس/الجمعة)
} as const;

export type DayTypeValue = (typeof DayType)[keyof typeof DayType];

export const DayTypeLabels: Record<DayTypeValue, string> = {
  all: 'كل الأيام',
  weekday: 'وسط الأسبوع',
  weekend: 'ويكند',
};

// ═══════════════════════════════════════════════════
// Season (الموسم)
// ═══════════════════════════════════════════════════
export const Season = {
  ALL: 'all',           // كل المواسم
  SCHOOL: 'school',     // موسم المدارس
  SUMMER: 'summer',     // الصيف
  HOLIDAY: 'holiday',   // الإجازات
  EID: 'eid',           // الأعياد
} as const;

export type SeasonValue = (typeof Season)[keyof typeof Season];

export const SeasonLabels: Record<SeasonValue, string> = {
  all: 'كل المواسم',
  school: 'موسم المدارس',
  summer: 'الصيف',
  holiday: 'الإجازات',
  eid: 'الأعياد',
};

export const SeasonIcons: Record<SeasonValue, string> = {
  all: '📅',
  school: '🎒',
  summer: '☀️',
  holiday: '🌴',
  eid: '🎉',
};

// ═══════════════════════════════════════════════════
// القيم المستخدمة في النماذج والفلاتر
// ═══════════════════════════════════════════════════
export const ALL_SECTION_MODES: SectionModeValue[] = [
  SectionMode.BOTH,
  SectionMode.MEN,
  SectionMode.WOMEN,
];

export const ALL_DAY_TYPES: DayTypeValue[] = [
  DayType.ALL,
  DayType.WEEKDAY,
  DayType.WEEKEND,
];

export const ALL_SEASONS: SeasonValue[] = [
  Season.ALL,
  Season.SCHOOL,
  Season.SUMMER,
  Season.HOLIDAY,
  Season.EID,
];

/**
 * يحوّل dayOfWeek (JS getDay: الأحد=0 … السبت=6) إلى DayType.
 *
 * 🇸🇦 قاعدة قاعات السعودية (مطابقة لتطبيق Flutter — EventDateClassifier):
 *   - الخميس (4) + الجمعة (5) → weekend
 *   - السبت إلى الأربعاء       → weekday
 */
export function dayOfWeekToDayType(dayOfWeek: number): DayTypeValue {
  if (dayOfWeek === 4 || dayOfWeek === 5) {
    return DayType.WEEKEND;
  }
  return DayType.WEEKDAY;
}
